<template>
    <div class="animated fadeIn">

        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-industry text-primary mr-2"></i>
                    Nuevo Recibo
                </h4>
            </b-col>
        </b-row>

        <b-row class="my-2">
            <b-col>
                <b-card>
                    <b-row class="pt-2">
                        <b-col sm="12" md="6">

                            <b-tabs>
                                <b-tab title="Socio" no-body>
                                    <b-row class="px-2 pt-2">
                                        <member-search-small @submit-member="setMember($event)"></member-search-small>
                                    </b-row>

                                    <b-row v-if="!!client && clientType==='member'" class="animated fadeIn px-4 pt-3 pb-2">
                                        <member-summary-small :member="client"></member-summary-small>
                                    </b-row>
                                </b-tab>
                            </b-tabs>
                        </b-col>

                        <b-col cols="12" md="4">
                                <b-form-group
                                    label="<strong>Fecha de Cargo *</strong>"
                                    label-for="chargeFromDate">
                                    <v-date-picker
                                            id="chargeFromDate"
                                            v-model="chargeFromDate"
                                            :input-props='{ placeholder: "Fecha de cargo" }'
                                            class="date-picker-w-100 date-picker-custom-border">
                                        </v-date-picker>
                                   
                                </b-form-group>
                                <b-form-group
                                    label="<strong>Importe *</strong>"
                                    label-for="amountTotal">
                                    <b-form-input
                                        type="text"
                                        placeholder="Importe"
                                        v-model="amountTotal">
                                    </b-form-input>
                                </b-form-group>
                        </b-col>
                    </b-row>


                    <b-row v-if="mixinCheckPermission('RECEIPT_NEW')" class="flex-row-reverse px-3 my-2">
                        <button
                            :disabled="!validReceipt"
                            class="btn btn-brand btn-primary btn-lg"
                            @click="saveReceipt()">
                            Guardar
                        </button>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import MemberSearchSmall from '@/components/clients/members/MemberSearchSmall';
    import MemberSummarySmall from '@/components/clients/members/MemberSummarySmall';
    import PaymentMethodSelector from '@/components/clients/members/PaymentMethodSelector';

    import {createReceiptCustom} from '@/api/receipt-api';
    import moment from 'moment';

    import {setupCalendar, DatePicker} from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';

    setupCalendar({
        firstDayOfWeek: 2, // Monday
    });

    export default {
        name: "AddReceipt",
        components: {
            'v-date-picker': DatePicker,
            MemberSearchSmall,
            MemberSummarySmall,
            PaymentMethodSelector
        },
        created() {
   
            this.$eventHub.$emit('captureMenu', this.topMenu);

            let date = new Date();
            //date.setDate(1);

            this.chargeFromDate = date;
            
        },
        data: function () {
            return {
                topMenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    }
                ],
                client: null,
                clientType: null,
                chargeFromDate: null,
                amountTotal: null,
            };
        },
        computed: {
            validReceipt() {
                return (
                    !!this.client
                    && !!this.chargeFromDate
                    && !!this.amountTotal
                );
            },
            receiptObject() {
                const memberId = this.client.uuid;
                const amount = this.amountTotal;
                let d = new Date(this.chargeFromDate)
                d.setHours(0);
                d.setMinutes(0);
                d.setSeconds(0);
                const chargeFromDate = moment(d).toJSON();
                return {
                    memberId,
                    amount: Number(amount),
                    chargeFromDate: chargeFromDate
                }
            }
        },
        methods: {
            setMember(member) {
                this.client = Object.assign({}, member);
                this.clientType = 'member';
            },
            async saveReceipt() {
                if (this.validReceipt) {
                    this.$_loadingMixin_showLoading();
                    await createReceiptCustom(this.receiptObject)
                        .then(() => {
                            this.$_notificationMixin_success(
                                'Operación completada',
                                'Las remesas se han creado con éxito'
                            );
                            this.$router.push({path: '/accounting/receipts/list'});
                        })
                        .catch(() => {
                            this.$_notificationMixin_error(
                                'Operación no completada',
                                'Se ha producido un error'
                            );
                        });
                    this.$_loadingMixin_hideLoading();
                } else {
                    this.$_notificationMixin_error(
                        'Error en el formulario',
                        'Revise los campos'
                    );
                }
            }
        },
        watch: {
            
        }
    }
</script>

<style scoped>

</style>